"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Times = exports.Svg = exports.Substract = exports.Icon = exports.Exclamation = exports.ChevronRight = exports.ChevronLeft = exports.Check = exports.Add = void 0;
var _react = _interopRequireDefault(require("react"));
var _box = require("@oneloop/box");
var _excluded = ["color"],
  _excluded2 = ["color"],
  _excluded3 = ["color"],
  _excluded4 = ["color"],
  _excluded5 = ["color"],
  _excluded6 = ["color"],
  _excluded7 = ["color"],
  _excluded8 = ["icon", "fontSize"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Svg = exports.Svg = function Svg(props) {
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "currentcolor"
  }, props));
};
var Times = exports.Times = function Times(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'black' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(Svg, props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z",
    fill: color
  }));
};
var Check = exports.Check = function Check(_ref2) {
  var _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'black' : _ref2$color,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(Svg, _extends({
    width: "22px",
    height: "17px",
    viewBox: "0 0 22 17",
    fill: "none"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.18359 7.64653L3.83128 7.29423L3.47773 7.64529L2.05773 9.05529L1.70168 9.40884L2.05648 9.76364L7.64648 15.3536L8.00003 15.7072L8.35359 15.3536L20.3536 3.35364L20.7071 3.00009L20.3536 2.64653L18.9436 1.23653L18.5902 0.883148L18.2366 1.23637L8.0002 11.4631L4.18359 7.64653Z",
    fill: color
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.18359 7.64653L3.83128 7.29423L3.47773 7.64529L2.05773 9.05529L1.70168 9.40884L2.05648 9.76364L7.64648 15.3536L8.00003 15.7072L8.35359 15.3536L20.3536 3.35364L20.7071 3.00009L20.3536 2.64653L18.9436 1.23653L18.5902 0.883148L18.2366 1.23637L8.0002 11.4631L4.18359 7.64653Z",
    fill: color
  }));
};
var Exclamation = exports.Exclamation = function Exclamation(_ref3) {
  var _ref3$color = _ref3.color,
    color = _ref3$color === void 0 ? 'black' : _ref3$color,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(Svg, _extends({
    width: "4px",
    height: "19px",
    viewBox: "0 0 4 19",
    fill: "none"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0.666748H0V12.6667H4V0.666748ZM0 16.6667C0 15.5622 0.89543 14.6667 2 14.6667C3.10457 14.6667 4 15.5622 4 16.6667C4 17.7713 3.10457 18.6667 2 18.6667C0.89543 18.6667 0 17.7713 0 16.6667Z",
    fill: color
  }));
};
var Substract = exports.Substract = function Substract(_ref4) {
  var _ref4$color = _ref4.color,
    color = _ref4$color === void 0 ? 'black' : _ref4$color,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_react["default"].createElement(Svg, {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.25 9.75001H9.75H8.25H3.75V8.25001H8.25L9.75 8.24994L14.25 8.25001V9.75001Z",
    fill: color
  }));
};
var Add = exports.Add = function Add(_ref5) {
  var _ref5$color = _ref5.color,
    color = _ref5$color === void 0 ? 'black' : _ref5$color,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_react["default"].createElement(Svg, {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.25 9.75H9.75V14.25H8.25V9.75H3.75V8.25H8.25V3.75H9.75V8.25H14.25V9.75Z",
    fill: color
  }));
};
var ChevronLeft = exports.ChevronLeft = function ChevronLeft(_ref6) {
  var _ref6$color = _ref6.color,
    color = _ref6$color === void 0 ? 'black' : _ref6$color,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_react["default"].createElement(Svg, _extends({
    width: "8",
    height: "12",
    viewBox: "0 0 18 12",
    fill: "none"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.41 1.41L6 0L0 6L6 12L7.41 10.59L2.83 6L7.41 1.41Z",
    fill: color
  }));
};
var ChevronRight = exports.ChevronRight = function ChevronRight(_ref7) {
  var _ref7$color = _ref7.color,
    color = _ref7$color === void 0 ? 'black' : _ref7$color,
    props = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_react["default"].createElement(Svg, _extends({
    width: "8",
    height: "12",
    viewBox: "0 0 18 12",
    fill: "none"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.00009 0L0.590088 1.41L5.17009 6L0.590088 10.59L2.00009 12L8.00009 6L2.00009 0Z",
    fill: color
  }));
};
var Icon = exports.Icon = function Icon(_ref8) {
  var icon = _ref8.icon,
    fontSize = _ref8.fontSize,
    props = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({}, props, {
    __css: {
      display: 'grid',
      placeItems: 'center',
      width: fontSize,
      height: fontSize
    }
  }), /*#__PURE__*/_react["default"].createElement("i", {
    className: icon,
    style: {
      fontSize: fontSize,
      width: fontSize,
      height: fontSize
    }
  }));
};